import { Badge } from '@/components/ui/badge'
import {
  Card,
  CardAction,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import type { DashboardMetrics } from '@/types/dashboard'
import { TrendingDown, TrendingUp } from 'lucide-react'

function MetricCard({
  label,
  value,
  change,
  comparisonLabel,
  description,
}: {
  label: string
  value: string
  change?: number | null
  comparisonLabel?: string
  description: string
}) {
  const hasChange = typeof change === 'number'
  const isPositive = hasChange && change >= 0

  return (
    <Card className="@container/card">
      <CardHeader>
        <CardDescription>{label}</CardDescription>
        <CardTitle className="text-2xl font-semibold tabular-nums @[250px]/card:text-3xl">
          {value}
        </CardTitle>
        {hasChange && (
          <CardAction>
            <Badge variant="outline">
              {isPositive ? <TrendingUp /> : <TrendingDown />}
              {isPositive ? '+' : ''}
              {change}%
            </Badge>
          </CardAction>
        )}
      </CardHeader>
      <CardFooter className="flex-col items-start gap-1.5 text-sm">
        {hasChange && comparisonLabel && (
          <div className="line-clamp-1 flex gap-2 font-medium">
            {isPositive ? 'Aumento' : 'Queda'} de {Math.abs(change)}%
            {' '}comparado com {comparisonLabel}
            {isPositive ? (
              <TrendingUp className="size-4" />
            ) : (
              <TrendingDown className="size-4" />
            )}
          </div>
        )}
        <div className="text-muted-foreground">{description}</div>
      </CardFooter>
    </Card>
  )
}

export function SectionCards({ metrics, isMember = false }: { metrics: DashboardMetrics; isMember?: boolean }) {
  return (
    <div className="*:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card grid grid-cols-1 gap-4 *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:shadow-xs @xl/main:grid-cols-2">
      <MetricCard
        label={isMember ? 'Suas Vendas Hoje' : 'Vendas Hoje'}
        value={metrics.salesToday.count.toLocaleString('pt-BR')}
        change={metrics.salesToday.change}
        comparisonLabel="ontem"
        description="Vendas realizadas hoje"
      />
      <MetricCard
        label={isMember ? 'Suas Vendas Este Mês' : 'Vendas Este Mês'}
        value={metrics.salesThisMonth.count.toLocaleString('pt-BR')}
        change={metrics.salesThisMonth.change}
        comparisonLabel="mês anterior"
        description="Vendas desde o início do mês"
      />
    </div>
  )
}
